import { makeStyles, tokens } from '@fluentui/react-components';
import { fontScale } from '@/theme';

export const useAuthLoadingStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    padding: tokens.spacingVerticalXXL,
    gap: tokens.spacingVerticalL,
  },
  message: {
    fontSize: fontScale.subtitle,
    color: tokens.colorNeutralForeground2,
  },
});
